<template>
  <div>
    <div class="tw-mb-4 tw-flex tw-flex-wrap tw-items-end tw-justify-between tw-gap-3">
      <p class="tw-text-muted tw-mb-0 tw-text-sm">Disabled jobs show in muted text.</p>
      <div class="field tw-mb-0" style="min-width: 220px">
        <label class="field-label">Sort by</label>
        <SelectButton v-model="orderByName" :options="orderByOptions" optionLabel="label" optionValue="value" />
      </div>
    </div>

    <query-loader
      :query="gql => gql`
        query CronSchedules($sourceName: String) {
          cronSchedules(sourceName: $sourceName) {
            sourceName
            sync { cronStrings nextDate enabled }
            purge { cronStrings nextDate enabled }
            reconcile { cronStrings nextDate enabled }
          }
        }
      `"
      :variables="{ sourceName }"
    >
      <template v-slot="{ data, refresh }">
        <div class="tw-mb-3 tw-flex tw-justify-end">
          <Button label="Refresh" icon="pi pi-refresh" class="p-button-outlined p-button-sm" @click="refresh" />
        </div>
        <Card>
          <template #title>Schedules</template>
          <template #subtitle>Sync · purge · reconcile by feed</template>
          <template #content>
            <CronSchedulesUserConfig v-if="orderByName === 'userConfig'" :cron-schedules="data.cronSchedules" />
            <CronSchedulesNextRun v-else-if="orderByName === 'datetime'" :cron-schedules="data.cronSchedules" />
          </template>
        </Card>
      </template>
    </query-loader>
  </div>
</template>

<script>
import CronSchedulesNextRun from './CronSchedulesNextRun'
import CronSchedulesUserConfig from './CronSchedulesUserConfig'
import { makeGlobalSettings } from '../lib/utils/index'

const orderByOptions = [
  { label: 'Config order', value: 'userConfig' },
  { label: 'Next run', value: 'datetime' },
]

export default {
  props: {
    sourceName: {
      type: String,
      required: false,
    },
  },
  data() {
    return { orderByOptions }
  },
  computed: {
    ...makeGlobalSettings({
      orderByName: 'cronPage.orderByName',
    }),
  },
  components: {
    CronSchedulesNextRun,
    CronSchedulesUserConfig,
  },
}
</script>
